import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=fe909870&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Profile.vue?vue&type=style&index=0&id=fe909870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe909870",
  null
  
)

export default component.exports